import type { RelativeAbsolutePosition } from '../../core/types/pointer-events.js';
import type { XYChartState } from '../types/state.js';

export function reduceResetInteractions(
  {
    zoomStatus,
  }: {
    position?: RelativeAbsolutePosition;
    zoomStatus?: Partial<XYChartState['zoom']>;
  } = { zoomStatus: {} },
) {
  return (prev: XYChartState): XYChartState => ({
    ...prev,
    interactionMode: 'explore',
    highlightedSeriesId: undefined,
    select: undefined,
    currentDomain: undefined,
    zoom: {
      zoomInEnabled: true,
      zoomOutEnabled: false,
      ...zoomStatus,
    },
  });
}
